import Modul, {UpdateResponse} from './Modul';

interface WebcomponentInstance {
    instanceId: string;
    hasEditView: boolean;
    getFormData(elem: JQuery): any;
    getMainJQ(type: string): JQuery;
    saveEditData(data: JQueryAjaxSettings): void;
}

interface WebcomponentInstanceCreator {
    create(data: any, baseSaveUrl: string, fn: (data: any, instance: WebcomponentInstance) => void): void;
}

declare var diysdk: {
    webcomponentIntegrator: new() => WebcomponentInstanceCreator;
    webcomponents: {
        [webcomponentInstanceId: string]: WebcomponentInstance;
    }
};

export default class ModulWebcomponent extends Modul {
    private instance: WebcomponentInstance;

    /**
     * Creates a instance of a webcomponent
     *
     * @param {} data
     * @param {string} baseSaveUrl
     * @param {function|null} success
     */
    createInstance(data: any, baseSaveUrl: string, success: () => void) {
        let instanceCreator = new diysdk.webcomponentIntegrator();
        instanceCreator.create(data, baseSaveUrl, (data, instance) => {
            this.instance = instance;

            if (this.instance && this.instance.hasEditView === false) {
                this.hasConfigView = false;
            }

            if (typeof success === "function") {
                success();
            }
        });
    }

    getSaveData() {
        let data: any = {
            'moduleId': this.moduleId,
            'form_data': JSON.stringify(this.instance.getFormData(this.instance.getMainJQ('edit'))),
            'cstok': jimdoData.cstok
        };
        if (this.getIsNew()) {
            data._diyNewlyAdded = 1;
        }
        return data;
    }
    /**
     * XHR Request to app server to save/update a webcomponent
     */
    runSaveAction() {
        if (this.instance) {
            this.showConfigLoading();

            this.instance.saveEditData({

                url: systemurl + 'app/module/webcomponent/update',
                contentType: 'application/x-www-form-urlencoded',
                data : this.getSaveData(),
                dataType : 'json',
                success: (response) => {
                    /**
                     * Make some SiteCatalyst tracking
                     */
                    jQuery(document).trigger('diy-editor-makeWebsiteFit', {
                        'condition': 'Applied',
                        'name': 'Web Apps'
                    });

                    if (response.userHasInstalledApp === true) {
                        jQuery(document.body).trigger('InstalledWebAppSaved.BSA');
                    }

                    this.hideConfigLoading();
                    this.close(false, false);
                    this.setIsNew(false);
                    this.refreshModule(response);
                    jQuery(document).trigger('diy-editor-module-saved');
                },
                error: () => {
                    this.hideConfigLoading();
                }
            });
        }
    }

    onDelete() {
        if (typeof(diysdk.webcomponents[this.instance.instanceId]) !== 'undefined') {
            delete diysdk.webcomponents[this.instance.instanceId];
        }
        return true;
    }

    refreshModule(response: UpdateResponse) {
        if (response.cmsView && response.editView) {
            this.updateModul(response.cmsView, response.editView);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulWebcomponent.ts
 **/